import React from 'react';

import LazyComponent from '../../Components/LazyComponent';
import ImageBlurFallback from '../../Components/ImageBlurFallback';

import DESCRIPTION_IMAGE_FIRST_jpg from './../../Assets/v2/liveClass/LiveClassesEducation.jpeg';
import DESCRIPTION_IMAGE_SECOND_jpg from './../../Assets/v2/liveClass/LiveClassesEducation2.jpeg';

import DESCRIPTION_IMAGE_FIRST_webp from './../../Assets/v2/liveClass/LiveClassesEducation.webp';
import DESCRIPTION_IMAGE_SECOND_webp from './../../Assets/v2/liveClass/LiveClassesEducation2.webp';

import DESCRIPTION_IMAGE_FIRST_fallback from './../../Assets/fallbacks/liveClass/LiveClassesEducation.jpg';
import DESCRIPTION_IMAGE_SECOND_fallback from './../../Assets/fallbacks/liveClass/LiveClassesEducation2.jpg';

const Description = ({
  slideDirection = 'Right',
  title,
  description,
  image,
  direction,
  spacing,
  webpImage,
  fallbackImage = ''
}) => {
  return (
    <div
      style={{
        animation: `slideIn${slideDirection} 400ms ease  forwards`
      }}
      className={`${direction} eachDescriptorContainer`}>
      <div className="imageAlign">
        <ImageBlurFallback
          fallbackImage={fallbackImage}
          webpImage={webpImage}
          className="imageContainer"
          src={image}
        />
      </div>
      <TextComponent
        title={title}
        description={description}
        spacing={spacing}
      />
    </div>
  );
};

const TextComponent = ({ title, description, spacing }) => {
  return (
    <div className={`descriptor-container ${spacing}`}>
      <span className="title">{title}</span>
      <span className="description">{description}</span>
    </div>
  );
};

const ImpactfulLearning = () => {
  const titleSection1 = 'Impactful Learning for Everyone';
  const descriptionSection1 =
    'Our programs are taken by thousands of students globally who build competencies in these emerging areas to secure and grow their careers. Our focus is on creating industry relevant programs and crafting learning experiences that help candidates learn, apply and demonstrate capabilities in areas that are driving the future.'
  const descriptionSection2 =
    'At Alien Brains, we build a safe space for our students to interact, experiment and achieve a lot more than what the conventional institutions normally do. Instead of spoon feeding concepts, we drive them to success through our successful training procedures by making them do stuffs according to the industry standards.'
  const titleSection2 = 'Courses to Grab your Attention';
  return (
    <div className="impactfulLearningContainer">
      <LazyComponent>
        <Description
          slideDirection="Right"
          title={titleSection1}
          description={descriptionSection1}
          fallbackImage={DESCRIPTION_IMAGE_FIRST_fallback}
          image={DESCRIPTION_IMAGE_FIRST_jpg}
          webpImage={DESCRIPTION_IMAGE_FIRST_webp}
          direction="alignment-first"
        />
      </LazyComponent>

      <LazyComponent>
        <Description
          slideDirection="Left"
          title={titleSection2}
          description={descriptionSection2}
          fallbackImage={DESCRIPTION_IMAGE_SECOND_fallback}
          image={DESCRIPTION_IMAGE_SECOND_jpg}
          webpImage={DESCRIPTION_IMAGE_SECOND_webp}
          direction="alignment-second"
          spacing="space-left"
        />
      </LazyComponent>
    </div>
  );
};

export default ImpactfulLearning;



// WEBPACK FOOTER //
// ./src/Pages/LiveClasses/ImpactfulLearning.js